module.exports = __webpack_public_path__ + "static/media/covid19.aa63ccf1.png";